<template>


  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>

        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Vize Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search" label=" Ara" append-icon="search">
              </v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>




          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="formtarih" v-model="valid" lazy-validation>
                  <v-card flat>

                    <v-layout row wrap class="pa-1 project overdue">

                      <v-flex xs12 sm6 md2>
                        <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false"
                          :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-bind:defaultvalue="'ok'"
                          v-bind:value="Vize.BaslangicTarihi" v-model="Vize.BaslangicTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex xs12 sm6 md2>
                        <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false"
                          :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-bind:defaultvalue="'ok'"
                          v-bind:value="Vize.BitisTarihi" v-model="Vize.BitisTarihi"></tarihcomp>
                      </v-flex>

                      <v-flex>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small="" dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                            @click="filtrele()" color="info" fab dark>
                            <v-icon>filter_list</v-icon>
                          </v-btn>
                          <v-tooltip bottom="" :activator="el" v-model="tooltip">
                            <span>Arama Filtresi Ekle</span>
                          </v-tooltip>
                        </v-layout>
                      </v-flex>

                    </v-layout>
                  </v-card>
                </v-form>
              </v-flex>
              <v-flex xs12 pt-2 sm12 md12>

                <v-layout class=" project overdue" row wrap>

                  <v-flex xs12 sm12>
                    <v-card flat>
                      <v-card-title>
                        <v-spacer></v-spacer>

                      </v-card-title>
                      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                        :search="search">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>


                        <template slot="items" slot-scope="props">
                          <td class="text-xs-left">{{ props.item.Kayit_Tarihi | dateformat }}</td>
                          <td class="text-xs-left">{{ props.item.SatisGrubu }}</td>
                          <td class="text-xs-left">{{ props.item.Isim}}</td>
                          <td class="text-xs-left">{{ props.item.KonsoloslukAciklama}}</td>
                          <td class="text-xs-left">{{ props.item.Tip1_ }}</td>
                          <td class="text-xs-left">{{ props.item.VizeDurumu_}}</td>
                          <td class="text-xs-left">{{ props.item.PasaportNo}}</td>
                          <td class="text-xs-left">{{ props.item.Durum_}}</td>
                          <td class="justify-center layout px-0">
                            <v-btn icon class="mx-0" @click="getDetay(props.item)">
                              <v-icon color="teal">search</v-icon>
                            </v-btn>

                          </td>

                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Your search for "{{ search }}" found no results.
                        </v-alert>
                      </v-data-table>
                    </v-card>
                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                      v-model="snackbar">
                      {{ text1 }}
                      <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                    </v-snackbar>
                  </v-flex>
                </v-layout>
              </v-flex>


            </v-layout>
          </v-container>

          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card flat color="grey lighten-5">

              <v-card-title>Filtre Seçimi</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout row wrap justify-space-between column>

                            <v-flex xs12 sm12 md12>
                              <v-autocomplete hide-details="" clearable :items="vizedurumitems" label="Vize Durumu"
                                multiple item-text="text" v-model="Vize.VizeDurumu" item-value="value">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{item.text}}</span>
                                  </div>
                                  <span v-if="index === 1" class="grey--text body-2">(+{{ Vize.VizeDurumu.length -1}}
                                    diğer)</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-autocomplete hide-details="" clearable :items="pasaportdurumuitems"
                                label="Pasaport Durumu" multiple item-text="text" v-model="Vize.PasaportDurumu"
                                item-value="value">
                                <template slot="selection" slot-scope="{ item, index }">
                                  <div v-if="index === 0">
                                    <span>{{item.text}}</span>
                                  </div>
                                  <span v-if="index === 1"
                                    class="grey--text body-2">(+{{ Vize.PasaportDurumu.length -1}}
                                    diğer)</span>
                                </template>
                              </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-text-field label="Yolcu İsmi" v-model="Vize.YolcuAdi">
                              </v-text-field>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-checkbox v-model="Vize.Kargoda" label="Kargoda olan pasaportları göster"
                                hide-details=""></v-checkbox>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Filtrele</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog v-model="dialogdetay" scrollable="" persistent="" max-width="450px">
            <v-card flat color="grey lighten-5">

              <v-card-title>Vize Detayı</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row="" wrap="">

                  <v-flex xs12 sm12 md12>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>
                          <v-layout v-if="dialogdetay" row wrap>



                            <v-flex xs12 pb-1 sm12 md12>
                              <v-card flat class="black--text">
                                <v-card flat="">
                                  <v-card-actions>

                                    <v-layout row wrap class=" pa-1 project overdue">
                                      <v-flex xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                          <v-flex xs12 sm12 md12>
                                            <v-layout align-center="" justify-start="" fill-height="">
                                              <span class="subheading grey--text font-weight-"> Genel Bilgiler

                                              </span>
                                            </v-layout>
                                          </v-flex>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Cari Kod
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.Cari_Kod}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2  font-weight-thin">
                                                  Adı Soyadı
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2  font-weight-thin">
                                                  {{vizedetay.Isim}}</span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2  font-weight-thin">
                                                  GSM
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.GSM}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  T.C. No:
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.TcNo}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>


                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Verildiği Yer
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.VerildigiYer}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Veriliş Tarihi
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.VerilisTarihi | dateformat}}
                                                </span>
                                              </v-layout>
                                            </v-flex>

                                          </v-layout>
                                        </v-card>
                                      </v-flex>


                                    </v-layout>
                                  </v-card-actions>
                                </v-card>
                              </v-card>
                            </v-flex>

                            <v-flex xs12 pb-1 sm12 md12>
                              <v-card flat class="black--text">
                                <v-card flat="">
                                  <v-card-actions>

                                    <v-layout row wrap class=" pa-1 project overdue">
                                      <v-flex xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                          <v-flex xs12 sm12 md12>
                                            <v-layout align-center="" justify-start="" fill-height="">
                                              <span class="subheading grey--text font-weight-"> Pasaport
                                                Bilgileri
                                              </span>
                                            </v-layout>
                                          </v-flex>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Pasaport No
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.PasaportNo}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Pasaport Tip
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.PasaportTip_}}</span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Durumu
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.Durum_}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Teslim Tipi
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.TeslimTipi_}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>


                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Verildiği Yer
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.VerildigiYer}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Veriliş Tarihi
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.VerilisTarihi | dateformat}}
                                                </span>
                                              </v-layout>
                                            </v-flex>

                                          </v-layout>
                                        </v-card>
                                      </v-flex>


                                    </v-layout>
                                  </v-card-actions>
                                </v-card>
                              </v-card>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-card flat class="black--text">
                                <v-card flat="">

                                  <v-card-actions>

                                    <v-layout row wrap class="project overdue">
                                      <v-flex pa-1 xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                          <v-flex xs12 sm12 md12>
                                            <v-layout align-center="" justify-start="" fill-height="">
                                              <span class="subheading grey--text font-weight-"> Konsolosluk
                                                Bilgileri
                                              </span>
                                            </v-layout>
                                          </v-flex>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Konsolosluk
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.KonsoloslukAciklama}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Randevu Zamanı
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.RandevuZamani | dateformat}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Randevu Saati
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.RandevuSaati | gettime }} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>


                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Konsolosluğa Ver. Tar.
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.KonsVerilisTarihi | dateformat}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Konsolosluğa Çık. Tar.
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.KonsCikisTarihi | dateformat}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>






                                        </v-card>
                                      </v-flex>


                                    </v-layout>
                                  </v-card-actions>
                                </v-card>
                              </v-card>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-card flat class="black--text">
                                <v-card flat="">

                                  <v-card-actions>

                                    <v-layout row wrap class="project overdue">
                                      <v-flex pa-1 xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                          <v-flex xs12 sm12 md12>
                                            <v-layout align-center="" justify-start="" fill-height="">
                                              <span class="subheading grey--text font-weight-"> Vize Bilgileri

                                              </span>
                                            </v-layout>
                                          </v-flex>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Takip No
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.SatisGrubu}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Tipi
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.Tip1_}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>


                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Türü
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.VizeTuru}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Durumu
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.VizeDurumu_}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Talep Edilen Dönem
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.IstenenDonem1}} - {{vizedetay.IstenenDonem2}}
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Alınan Dönem
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.Donem1}} - {{vizedetay.Donem2}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>




                                        </v-card>
                                      </v-flex>


                                    </v-layout>
                                  </v-card-actions>
                                </v-card>
                              </v-card>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-card flat class="black--text">
                                <v-card flat="">

                                  <v-card-actions>

                                    <v-layout row wrap class="project overdue">
                                      <v-flex pa-1 xs12 sm12 md12>
                                        <v-card flat class="black--text">
                                          <v-flex xs12 sm12 md12>
                                            <v-layout align-center="" justify-start="" fill-height="">
                                              <span class="subheading grey--text font-weight-"> Kargo Bilgileri

                                              </span>
                                            </v-layout>
                                          </v-flex>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Kargo Fiş No
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.KargoFisNo}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>

                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Kargo Adı
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.KargoIsmi}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>


                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Şube
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.KargoTeslimEdilecekSube}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>



                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Kargo Tel
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.KargoTeslimEdilecekTel}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Talep Edilen Dönem
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.IstenenDonem1}} - {{vizedetay.IstenenDonem2}}
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>
                                          <v-layout>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-start="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  Alınan Dönem
                                                </span>
                                              </v-layout>
                                            </v-flex>
                                            <v-flex xs6 sm6 md6>
                                              <v-layout align-center="" justify-end="" fill-height="">
                                                <span class="body-2 font-weight-thin">
                                                  {{vizedetay.Donem1}} - {{vizedetay.Donem2}} </span>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                          <v-divider light></v-divider>




                                        </v-card>
                                      </v-flex>


                                    </v-layout>
                                  </v-card-actions>
                                </v-card>
                              </v-card>
                            </v-flex>


                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>



                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogdetay=false">Tamam</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>



        </v-layout>
      </v-card>
    </v-app>

  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from "@/components/app/customcomp/tarihim"
  import tool from "../coper/tools";

  export default {
    data() {
      return {
        dialogdetay: false,
        vizedetay: [],
        Vize: {
          HesapKodu: null,
          BaslangicTarihi: null,
          BitisTarihi: null,
          YolcuAdi: null,
          VizeDurumu: null,
          PasaportDurumu: null,
          Kargoda: false
        },

        vizedurumitems: [{
            text: 'Vize Çıktı',
            value: 0
          },
          {
            text: 'İşlemde',
            value: 1
          },
          {
            text: 'Eksik Evrak',
            value: 2
          },
          {
            text: 'Red/İade',
            value: 3
          },
          {
            text: 'Ofiste',
            value: 4
          }
        ],
        pasaportdurumuitems: [{
            text: 'Teslim Edildi',
            value: 0
          },
          {
            text: 'Kasada/Hazırlık',
            value: 1
          },
          {
            text: 'Konsoloslukta',
            value: 2
          },
          {
            text: 'Kasada/işlem Tamam',
            value: 3
          }
        ],

        headers: [{
            text: 'Tarih',
            value: 'Kayit_Tarihi'
          },
          {
            text: 'Takip No',
            value: 'SatisGrubu'
          },
          {
            text: 'Adı Soyadı',
            value: 'Isim'
          },
          {
            text: 'Konsolosluk',
            value: 'KonsoloslukAciklama'
          },
          {
            text: 'Vize Tipi',
            value: 'Tip1_'
          },
          {
            text: 'Vize Durumu',
            value: 'VizeDurumu_'
          },
          {
            text: 'Pasaport No',
            value: 'PasaportNo'
          },
          {
            text: 'Pasaport Durumu',
            value: 'Durum_'
          },
          {
            text: '',
            value: ''
          }
        ],

        secilenevraklar: [],
        tumsirketler: '',
        devir: 0,
        acilisDevir: 0,
        kasaDevir: 0,
        oncekiDonemAlacak: 0,
        oncekiDonemBakiye: 0,
        oncekiDonemBorc: 0,
        toplamAlacak: 0,
        toplamBorc: 0,
        donemAlacak: 0,
        donemBorc: 0,
        StartDate: null,
        EndDate: null,


        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        statecari: [],
        searchcari: '',

        evraktipi: [],
        doviztipi: [],
        anahesap: [],
        valid: true,


        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        progress: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
        search: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
            tarihsec1: {
              required: () => 'Lütfen bir tarih seçiniz'
            },
          }
        },
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp
    },
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el



      var params = {
        HesapKodu: "ARKW000000002",
        BaslangicTarihi: "2020-01-01T00:00:00",
        BitisTarihi: "2020-03-01T00:00:00",
        YolcuAdi: null,
        VizeDurumu: null,
        PasaportDurumu: null,
        Kargoda: false
      }



    },
    watch: {

    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
      gettime: function (m) {
        return helpers.getTime(m)
      }

    },
    methods: {
      getDetay: getDetay,
      getList: getList,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }



  function filtrele() {
    this.dialogfiltre = true
  }


  function filtrekayit() {
    this.getList();
    this.dialogfiltre = false

  }

  function filtreiptal() {

    this.Vize.YolcuAdi = null
    this.Vize.VizeDurumu = null
    this.Vize.PasaportDurumu = null
    this.Vize.Kargoda = false
    this.dialogfiltre = false
  }

  function getList() {


    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.Vize.BaslangicTarihi)
      var bittarih = new Date(this.Vize.BitisTarihi)

      if (bastarih <= bittarih) {


        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Vize.HesapKodu = credentials.CariBilgi.Kod
        var params = this.Vize

        tool.http_post(this, 'VizeRaporuDot9', params).then(
          response => {
            this.progress = false
            this.load1 = true
            if (response.body.Status == true) {

              this.items = response.body.data


            } else

            {
              this.text1 = response.body.ErrorList[0]
              this.snackbar = true
            }
          },

          response => {
            this.text1 = 'Hata Oluştu, tekrar deneyiniz'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        );



      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }


  }


  function getDetay(val) {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      SirketNo: val.SirketNo,
      VizeRef: val.Ref
    }


    tool.http_post(this, 'GetVizeDot9', params).then(
      response => {
        this.progress = false
        this.load1 = true
        if (response.body.Status == true) {
          this.dialogdetay = true
          console.lo
          this.vizedetay = response.body.data[0]


        } else

        {
          this.text1 = response.body.ErrorList[0]
          this.snackbar = true
        }
      },

      response => {
        this.text1 = 'Hata Oluştu, tekrar deneyiniz'
        this.snackbar = true
        this.progress = false
        this.load1 = true
      }
    );


  }



  function getListExcel() {



    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.Vize.BaslangicTarihi)
      var bittarih = new Date(this.Vize.BitisTarihi)

      if (bastarih <= bittarih) {


        this.progress = true
        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.Vize.HesapKodu = credentials.CariBilgi.Kod
        var params = this.Vize

      this.$http.post(auth.API_URL + 'api/Coper/VizeRaporuDot9Excel', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader(),
          'CariSirketNo': credentials.CariBilgi.SirketKodu.toString(),
          'CoperSirketNo': credentials.CariBilgi.CoperSirketNo.toString(),
        },
        responseType: "arraybuffer"
      }).then((response) => {
        this.load = false
        this.load1 = true
        this.progress = false
        var blob = new Blob([response.data], {
          type: 'application/xlsx'
        });
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = "VizeRaporu.xlsx";
        link.click();

      }, (response) => {
        if (response.status === 0) {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        } else {
          this.text = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false

        }
      })

      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }

  }

  function beforeMount() {

  }
</script>


<style>
</style>